<template>
	<div class="watch-dashboard-widget time-line-widget">
		<div class="watch-dashboard-widget-header">
			<h1>{{ $t('base.watch.timeline') }}</h1>
		</div>
		<div class="watch-dashboard-widget-body">
			<spinner v-if="loading"/>
			<div v-else-if="data.length" class="time-line-events">
				<time-line-event
					v-for="item in data"
					:key="item.key"
					:event="item"
					:user_uid="user_uid"
					:watch_id="watch_id"/>
			</div>
			<p v-else>{{ $t('base.watch.no_events') }}</p>
		</div>
	</div>
</template>

<script>
import TimeLineEvent from './timeline/TimeLineEvent'
export default {
	components: {
		TimeLineEvent
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			healthreports: {
				loading: false,
				data: []
			},
			medicaldocuments: {
				loading: false,
				data: []
			}
		}
	},
	computed: {
		data () {
			let data = []
			this.healthreports.data.forEach(element => {
				data.push({
					type: 'HR',
					id: element.id,
					link_id: element.id,
					key: `HR_${element.id}`,
					title: element.name,
					description: element.report,
					datetime: '(datetime)',
					file: element.attachments.length ? element.attachments[0].file : null
				})
			})
			this.medicaldocuments.data.forEach(element => {
				data.push({
					type: 'MD',
					id: element.id,
					link_id: element.categories_id,
					key: `MD_${element.id}`,
					title: element.name,
					description: element.description,
					datetime: '(datetime)',
					file: element.file
				})
			})
			return data
		},
		loading () {
			return this.healthreports.loading || this.medicaldocuments.loading
		}
	},
	watch: {
		'$route' () {
			this.getAll()
		}
	},
	methods: {
		getHealthReports () {
			this.healthreports.loading = true
			this.healthreports.data = []
			this.$api.healthreports.getAll(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch dashboard timeline', 'healthreports.getAll OK', response)()
				this.healthreports.data = response.body
			}).catch(errors => {
				this.$log.error('watch dashboard timeline', 'healthreports.getAll ERROR', errors)()
			}).finally(() => {
				this.healthreports.loading = false
			})
		},
		getMedicalDocuments () {
			this.medicaldocuments.loading = true
			this.medicaldocuments.data = []
			this.$api.medicaldocuments.getAll(this, this.user_uid, this.watch_id).then(response => {
				this.$log.info('watch dashboard timeline', 'medicaldocuments.getAll OK', response)()
				this.medicaldocuments.data = response.body
			}).catch(errors => {
				this.$log.error('watch dashboard timeline', 'medicaldocuments.getAll ERROR', errors)()
			}).finally(() => {
				this.medicaldocuments.loading = false
			})
		},
		getAll() {
			this.getHealthReports()
			this.getMedicalDocuments()
		}
	},
	mounted () {
		this.getAll()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/TimeLineWidget.vue